import Card from "@erecht24/frontend-kit/theme/components/cards/Card";
import CardBody from "@erecht24/frontend-kit/theme/components/cards/CardBody";
import AddressForm from "./AddressForm";
import {useContext} from "react";
import {StateContext} from "../Contexts";
import AddressSummary from "./AddressSummary";



export default function Address(props) {
    /** @type CheckoutState */
    const state = useContext(StateContext);

    /**
     * Determines whether the summary should be displayed based on the state of the application.
     * It checks multiple conditions including the status of the address form, customer data,
     * and validation results for customer and payment data.
     *
     * @return {boolean} Returns true if all conditions to show the summary are met, false otherwise.
     */
    function shouldShowSummary() {
        return (
            !state.addressFormEnabled && // if the address form is disabled, we show the summary
            !state.paymentProviderChangeModeEnabled && // if the payment provider change mode is disabled, we show the summary
            state.contractData?.customer?.Address?.City && // if the customer has a city, we show the summary
            state.customerDataValidation.length < 1 && // if the customer data is valid, we show the summary
            state.paymentDataValidation.length < 1 // if the payment data is valid, we show the summary
        );
    }

    const addressView = shouldShowSummary()
        ? <AddressSummary/>
        : <AddressForm/>;

    return (
        <Card {...props}>
            <CardBody>
                {addressView}
            </CardBody>
        </Card>
    );
}
